export default {
    cn: {
        auditTrailReport: {
            indexText: '审核跟踪报表',
            detailText: '审核跟踪明细报表',
            goback: '返回',
            start_time: "开始时间：",
            end_time: "结束时间：",
            selectTimeText: '选择日期',
            clauses_text: "显示条目数",
            amount: "总数",
            present: "当前",
            downloadExcelForms: "下载 Excel",
            nodata: "没有查询到数据",
            search: '搜索',
            type: '类别：',
            account: '账号：',
            typeList: { "0": "增加", "1": "修改", "2": "刪除" },
            category: { "-1": "所有", "0": "代理", "1": "销售" },
            indexTh: [{
                key: 'type',
                name: '类别'
            }, {
                key: 'MODIFIED_ID',
                name: '账号'
            }, {
                key: 'NAME',
                name: '名称'
            }, {
                key: 'COUNT',
                name: '添加修改次数'
            }, {
                key: 'begintime',
                name: '开始时间',
                upper: false,
                changeTime: true
            }, {
                key: 'endtime',
                name: '结束时间',
                upper: false,
                changeTime: true
            }],
            detailTh: [{
                key: 'type',
                name: '类别'
            }, {
                key: 'DESCRIPTION',
                name: '描述'
            }, {
                key: 'LOG_DATE',
                name: '记录时间',
                changeTime: true
            }, {
                key: 'OLD_VALUE',
                name: '修改前的值'
            }, {
                key: 'NEW_VALUE',
                name: '修改后的值'
            }, {
                key: 'LOG_BY',
                name: '修改者'
            }]
        }
    },
    hk: {
        auditTrailReport: {
            indexText: '審核跟蹤報表',
            detailText: '審核跟蹤明細報表',
            goback: '返回',
            start_time: "開始時間：",
            end_time: "結束時間：",
            selectTimeText: '選擇日期',
            clauses_text: "顯示條目數",
            amount: "總數",
            present: "當前",
            downloadExcelForms: "下載 Excel",
            nodata: "沒有查詢到數據",
            search: "搜索",
            type: '類別：',
            account: '賬號：',
            typeList: { "0": "增加", "1": "修改", "2": "刪除" },
            category: { "-1": "所有", "0": "代理", "1": "銷售" },
            indexTh: [{
                key: 'type',
                name: '類別'
            }, {
                key: 'MODIFIED_ID',
                name: '賬號'
            }, {
                key: 'NAME',
                name: '名稱'
            }, {
                key: 'COUNT',
                name: '添加修改次數'
            }, {
                key: 'begintime',
                name: '開始時間',
                upper: false,
                changeTime: true
            }, {
                key: 'endtime',
                name: '結束時間',
                upper: false,
                changeTime: true
            }],
            detailTh: [{
                key: 'type',
                name: '類別'
            }, {
                key: 'DESCRIPTION',
                name: '描述'
            }, {
                key: 'LOG_DATE',
                name: '記錄時間',
                changeTime: true
            }, {
                key: 'OLD_VALUE',
                name: '修改前的值'
            }, {
                key: 'NEW_VALUE',
                name: '修改後的值'
            }, {
                key: 'LOG_BY',
                name: '修改者'
            }]
        }
    },
    en: {
        auditTrailReport: {
            indexText: 'Audit Trail Report',
            detailText: 'Audit Trail Detail Report',
            goback: 'Go Back',
            start_time: "Start Time：",
            end_time: "End time：",
            selectTimeText: 'Select Date',
            clauses_text: "Display",
            amount: " Total Count",
            present: "Current",
            downloadExcelForms: "Download Excel",
            search: "Search",
            nodata: "No data found",
            type: 'Type：',
            account: 'Account：',
            typeList: { "0": "Add", "1": "Update", "2": "Delete" },
            category: { "-1": "All", "0": "IB", "1": "Sales" },
            indexTh: [{
                key: 'type',
                name: 'Type'
            }, {
                key: 'MODIFIED_ID',
                name: 'Account'
            }, {
                key: 'NAME',
                name: 'Name'
            }, {
                key: 'COUNT',
                name: 'Count'
            }, {
                key: 'begintime',
                name: 'Start Time',
                upper: false,
                changeTime: true
            }, {
                key: 'endtime',
                name: 'End Time',
                upper: false,
                changeTime: true
            }],
            detailTh: [{
                key: 'type',
                name: 'Type'
            }, {
                key: 'DESCRIPTION',
                name: 'Description'
            }, {
                key: 'LOG_DATE',
                name: 'Log Date',
                changeTime: true
            }, {
                key: 'OLD_VALUE',
                name: 'Old Value'
            }, {
                key: 'NEW_VALUE',
                name: 'New Value'
            }, {
                key: 'LOG_BY',
                name: 'Log By'
            }]
        }
    }
}


// WEBPACK FOOTER //
// ./src/MultiLanguage/CommissionSetting/IB/auditTrailReport.js